module.exports = __webpack_public_path__ + "img/zz7.4ff7cae7.png";